export default __webpack_public_path__ + "static/media/collage.a0976c47.gif";